import React from 'react';
import { APP } from '../app/appConfig';

const About: React.FC = () => (
  <main id="main" className="mx-auto max-w-3xl px-4 sm:px-6 py-16">
    <h1 className="text-h1 font-display font-semibold mb-6">About</h1>
    <div className="space-y-5 text-body-lg text-text-secondary leading-relaxed">
      <p>{APP.brand.aboutIntro}</p>
      <p>
        Whether you are searching for a particular ragam, exploring a composer, or simply
        opening a bhajan to sit with for a while, the experience is meant to be quiet,
        legible, and reverent.
      </p>
      <p className="font-display italic text-accent-gold">bhakti-mārga-dīpa.</p>
    </div>
  </main>
);

export default About;
